module.exports = {"title":"Cost Calculator","gb_for":"GB* for","per_month":"per month excl. sales tax","gigs_over_xxx":"*each GB over 500GB is DKK 1,- each excl. sales tax"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 19
// module chunks = 0